module.exports = __webpack_public_path__ + "img/section5_img2_3.f9f0c74e.svg";